import { render, staticRenderFns } from "./ButtonImageAdd.vue?vue&type=template&id=86e40f36&scoped=true&"
import script from "./ButtonImageAdd.vue?vue&type=script&lang=js&"
export * from "./ButtonImageAdd.vue?vue&type=script&lang=js&"
import style0 from "./ButtonImageAdd.vue?vue&type=style&index=0&id=86e40f36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e40f36",
  null
  
)

export default component.exports